import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/jobDetails'
import * as api from '../api/job/jobs'

function* fetchJobDetails(action) {
  try {
    const payload = yield call(api.getJobDetails, action.jobId)
    yield put({ type: constants.JOB_DETAILS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_DETAILS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* jobDetailsRefresh() {
  yield takeLatest(constants.JOB_DETAILS_REFRESH.ACTION, fetchJobDetails)
}

function* fetchChildrenJobs(action) {
  try {
    const childrenJobs = yield call(api.getChildrenJobs, action.jobId)
    yield put({ type: constants.CHILDREN_JOBS.SUCCESS, childrenJobs })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CHILDREN_JOBS.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchChildrenJobs() {
  yield takeLatest(constants.CHILDREN_JOBS.ACTION, fetchChildrenJobs)
}

function* sagaUpdateJobDetails(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content
    }
    yield call(api.updateJobDetail, payload)
    yield put({ type: constants.JOB_DETAILS_UPDATE.SUCCESS, payload })
    yield call(fetchJobDetails, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_DETAILS_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobDetail() {
  yield takeLatest(constants.JOB_DETAILS_UPDATE.ACTION, sagaUpdateJobDetails)
}

function* sagaDeleteJob(action) {
  try {
    const payload = {
      job_id: action.jobId,
      user_id: action.userId
    }
    yield call(api.deleteJob, payload)
    payload.delete = true
    yield put({ type: constants.DELETE_JOB.SUCCESS, payload })
    yield call(fetchJobDetails, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_JOB.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJob() {
  yield takeLatest(constants.DELETE_JOB.ACTION, sagaDeleteJob)
}

function* sagaInactivateJob(action) {
  try {
    const payload = {
      job_id: action.jobId,
      user_id: action.userId
    }
    yield call(api.inactivateJob, payload)
    payload.delete = true
    yield put({ type: constants.INACTIVATE_JOB.SUCCESS, payload })
    yield call(fetchJobDetails, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.INACTIVATE_JOB.FAILED,
      message: e.message || e
    })
  }
}

function* watchInactivateJob() {
  yield takeLatest(constants.INACTIVATE_JOB.ACTION, sagaInactivateJob)
}

function* sagaActivateJob(action) {
  try {
    const payload = {
      job_id: action.jobId,
      user_id: action.userId
    }
    yield call(api.activateJob, payload)
    payload.delete = true
    yield put({ type: constants.ACTIVATE_JOB.SUCCESS, payload })
    yield call(fetchJobDetails, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVATE_JOB.FAILED,
      message: e.message || e
    })
  }
}

function* watchActivateJob() {
  yield takeLatest(constants.ACTIVATE_JOB.ACTION, sagaActivateJob)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(jobDetailsRefresh),
    fork(watchUpdateJobDetail),
    fork(watchDeleteJob),
    fork(watchFetchChildrenJobs),
    fork(watchInactivateJob),
    fork(watchActivateJob)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobDetails.js